export {};
export class Position {
    public left: number;
    public top: number;
    public constructor(left: number, top: number) {
        this.left = left;
        this.top = top;            
    }
}

declare global {    
    interface String {
        capitalize(): string;
    }
    interface HTMLElement {
        getOffset(): Position;
    }
}

// Position.prototype.constructor = function(left: number, top: number) {
//     this.left = left;
//     this.top = top;
// }

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function(this: string) {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

HTMLElement.prototype.getOffset = function(this: HTMLElement): Position {
    const rect = this.getBoundingClientRect();
    return new Position(Math.round(rect.left + window.scrollX), Math.round(rect.top + window.scrollY));
}